<template>
  <div class="footer">
    <div class="logo"></div>
    <div class="route">
      <span @click="$router.push('/Creative')">联系我们</span>|
      <span @click="$router.push('/Creative')">商务合作</span>|
      <span @click="$router.push('/gameplay')">客服中心</span>
    </div>
    <div class="route">
      <span @click="$router.push('/join')">加入我们</span>|
      <span @click="$router.push('/about')">关于我们</span>|
      <span @click="joinTo(2)">简历投递</span>
    </div>
    <div class="route">
      <span @click="$router.push('/reporting')">廉正举报</span>|
      <span @click="$router.push('/privacy')">隐私政策</span>|
      <span @click="$router.push('/gameplay')">成长关爱系统</span>|
      <span @click="$router.push('/addiction')"
        >网络游戏行业防沉迷自律公约</span
      >
      <!-- <div></div> -->
    </div>
    <div class="route">浙公网安备 33011002015285号</div>
    <div class="route" @click="openICP()">浙ICP备19026038号-1</div>
    <div class="route">浙网文 [2024] 2094-095号</div>
    <div class="route">增值业务电信经营许可证:浙B2-20200243</div>
    <div class="code">
      <img src="@/assets/layout/code.png" alt="" />关注公众号
    </div>
  </div>
</template>

<script>
import router from "../router";

export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    openICP() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    joinTo(type) {
      this.$router.push({
        path: "/joininfo",
        query: {
          type: type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 431px;
  background: url("@/assets/layout/footbg.png") no-repeat;
  background-size: 100% 100%;
  padding: 36px 0 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    width: 138px;
    height: 47px;
    background: url("@/assets/layout/footlogo.png") no-repeat;
    margin-bottom: 12px;
    background-size: 100% 100%;
  }
  .code {
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
      margin-right: 12px;
    }
    font-weight: 500;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
  }
  .route {
    font-weight: 400;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 16px;
    text-align: center;
    padding: 0 15px;
    span {
      margin: 0 15px;
    }
    div {
      margin-top: 5px;
    }
  }
}
</style>
